<!--页脚-->
<template>
  <div class="contact-box">
    <div class="contact-head">
      <span class="contact-title">联系我们</span>
    </div>
    <p class="contact-pblue">{{this.contact.name}}</p>
    <p class="contact-p">地址：{{this.contact.addr}}</p>
    <p class="contact-p">邮政编码：{{this.contact.code}}</p>
    <p class="contact-p">电子邮箱：{{this.contact.mail}}</p>
    <p class="contact-p">主页网址：{{this.contact.web}}</p>
    <p class="contact-p">电话：{{this.contact.tel}}</p>
    <p class="contact-p">传真：{{this.contact.fax}}</p>
  </div>
</template>

<script>
import HttpServer from '@/utils' // 接口请求
export default {
  data () {
    return {
      // 联系我们数据
      contact: ''
    }
  },
  mounted () {
    // 调用联系我们接口
    HttpServer.get('http://ysw.861718.com/gdics.php/index/contact').then(res => {
      this.contact = res
    })
  }
}
</script>

<style>
.contact-box{
  padding: 12px;
  background-color: #ffffff;
  font-size: 12px;
  text-align: left;
}
.contact-head{
  height:30px;
  margin-bottom: 15px;
  border-bottom: 1px solid #d7d7d7;
}
.contact-title{
  font-size: 14px
}
.contact-p{
  margin-bottom: 5px
}
.contact-pblue{
  color: #0051bd;
}
</style>



// WEBPACK FOOTER //
// src/components/contact/contact.vue